import React from 'react'
import styled from 'styled-components'
import { Button, Typography } from '@material-ui/core'
import WebIcon from '@material-ui/icons/Web'

import { useCircle, useCircleMembership } from 'circle/circle.selectors'
import { usePosts } from 'posts/posts.selectors'
import { isAdmin } from 'posts/isAdmin'
import { useProfile } from 'profile'

// Kept in step with LANDING_TAG in node-api/src/service/landing/landingService.ts.
const LANDING_TAG = '_landing'

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #f6fdf8;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
`

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`

/**
 * Admin-only note about the circle's public landing page.
 *
 * The page is whichever post in this circle is tagged `_landing` — the same
 * convention as `_widget`. There is nothing to configure, so this is a pointer
 * rather than an editor.
 */
const LandingPageLink = () => {
    const circle = useCircle()
    const membership = useCircleMembership()
    const { profile } = useProfile()
    const posts = usePosts()

    if (!circle) return null
    if (!isAdmin(membership) && profile?.role !== 'ADMIN') return null

    // The landing post is tagged, and admins see tagged posts in their feed, so
    // this needs no extra request.
    const hasLanding = Object.keys(posts?.map || {}).some(id => {
        const tags = posts.map[id]?.tags
        return tags && tags.includes(LANDING_TAG)
    })

    return (
        <Bar className="ns">
            <Label>
                <WebIcon fontSize="small" />
                <Typography variant="body2">
                    {hasLanding
                        ? 'This circle has a public landing page'
                        : `Tag a post "${LANDING_TAG}" to give this circle a public landing page`}
                </Typography>
            </Label>
            {hasLanding ? (
                <Button
                    size="small"
                    variant="outlined"
                    href={`/${circle._id}/landing`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View
                </Button>
            ) : null}
        </Bar>
    )
}

export default LandingPageLink
